export const normalizeLabel = (label: string): string =>
	label.toLowerCase().replace(/ /g, '-');
